import { render, staticRenderFns } from "./SoilHistory.vue?vue&type=template&id=7c62064b&scoped=true&"
import script from "./SoilHistory.vue?vue&type=script&lang=ts&"
export * from "./SoilHistory.vue?vue&type=script&lang=ts&"
import style0 from "./SoilHistory.vue?vue&type=style&index=0&id=7c62064b&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c62064b",
  null
  
)

export default component.exports